import React from "react";
import styled from "styled-components";
import { TextFont, Colors } from "../../config";
import NewBadge from "../BusinessTripComponents/Newbadge";

const NavbarItemInactive = ({ labelText, showBizTripTutorial }) => {
  return (
    <NavbarInactive showBizTripTutorial={showBizTripTutorial}>
      {labelText === "Book Business Trip" && <NewBadge bottomPixel="28px" />}
      {labelText === "Book Business Trip" && showBizTripTutorial ? (
        <SpotLight>
          {/* <NewBadge bottomPixel="24px" /> */}
          <TopText>
            <TextFont fontColor={Colors.brandTwo}>{labelText}</TextFont>
          </TopText>
          <SpotLightImg
            src={require("../../assets/images/biz-trip-spotlight.png")}
          />
          <ArrowImg src={require("../../assets/images/biz-trip-arrow.png")} />
        </SpotLight>
      ) : (
        <TextFont fontColor={Colors.brandTwo} fontWeight="500">
          {labelText}
        </TextFont>
      )}
    </NavbarInactive>
  );
};

export default NavbarItemInactive;

const SpotLight = styled.div`
  position: relative;
`;

const ArrowImg = styled.img`
  position: absolute;
  top: 0px;
  left: 220px;
  z-index: 11;
  transform: rotate(-15deg);
  transform-origin: center center;
  @media only screen and (max-width: 1480px) {
    top: 0px;
    left: 180px;
    transform: rotate(0deg);
    transform-origin: center center;
  }
  @media only screen and (max-width: 1400px) {
    top: 15px;
    left: 130px;
    transform: rotate(15deg);
    transform-origin: center center;
  }
  @media only screen and (max-width: 1200px) {
    top: 15px;
    left: 130px;
    transform: rotate(15deg);
    transform-origin: center center;
  }
  @media only screen and (max-width: 1149px) {
    top: 15px;
    left: 110px;
    transform: rotate(25deg);
    transform-origin: center center;
  }
  @media only screen and (max-width: 1077px) {
    top: 30px;
    left: 95px;
    transform: rotate(25deg);
    transform-origin: center center;
  }
`;

const SpotLightImg = styled.img`
  position: absolute;
  z-index: 11;
  top: -180px;
  left: -80px;
`;

const TopText = styled.div`
  z-index: 99;
  position: relative;
`;

const NavbarInactive = styled.div`
  position: relative;
  :hover {
    opacity: ${(props) => (props.showBizTripTutorial ? 1 : 0.6)};
  }
`;
